/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * A service to help manage category buying walkthru guide.
 *
 * @module enervee_utils.category_guide
 **/
CategoryGuideModalService.$inject = [
    '$location',
    '$timeout',
    'UtilService',
    'IndexService',
    'AnalyticsService',
];
function CategoryGuideModalService(
        $location,
        $timeout,
        UtilService,
        IndexService,
        AnalyticsService
    ) {
        var _pub = {};
        var DEFAULT_MODAL_NAME = '#modal-category-guide';
        var MODAL_DATA = [];

        _pub.categoryCode = '';

        /**
         * Gets data to display on steps of buying guide.
         *
         * @private
         */
        _pub.getStepsToDisplay = function() {
            return MODAL_DATA;
        };
         /**
         * Open category buying guide modal
         */
        _pub.displayCategoryGuideModal = function () {
            AnalyticsService.reportEvent('Category Walkthrough Viewed', {
                category: _pub.categoryCode,
                location: 'modal'
            });
            IndexService.openModal(DEFAULT_MODAL_NAME);
        };

         /**
         * Initialize category buying guide
         */
        _pub.initBuyingGuide = function (activeCategory) {
            var categoryBuyingGuideData = activeCategory.category_buying_guide;
            _pub.categoryCode = activeCategory.category_code;
            if (angular.isArray(categoryBuyingGuideData) && categoryBuyingGuideData.length > 0) {
                MODAL_DATA = categoryBuyingGuideData;
                if ($location.search().walkthrough === 'open') {
                    $timeout (function () {
                        IndexService.openModal(DEFAULT_MODAL_NAME);
                    });
                    AnalyticsService.reportEvent('Category Walkthrough Viewed', {
                        category: _pub.categoryCode,
                        location: 'modal',
                    });
                }
                return true;
            } else {
                MODAL_DATA = [];
                return false;
            }
        };

        return _pub;

}

module.exports = CategoryGuideModalService;
